import { render, staticRenderFns } from "./BrandSet.vue?vue&type=template&id=ca1ab140&scoped=true"
import script from "./BrandSet.vue?vue&type=script&lang=js"
export * from "./BrandSet.vue?vue&type=script&lang=js"
import style0 from "./BrandSet.vue?vue&type=style&index=0&id=ca1ab140&prod&scoped=true&lang=scss"
import style1 from "./BrandSet.vue?vue&type=style&index=1&id=ca1ab140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1ab140",
  null
  
)

export default component.exports